import { VolumeOff, VolumeUp, MoreVert } from "@mui/icons-material";
import { IconButton, Menu, MenuItem, Stack } from "@mui/material";
import { Tooltip } from "components/elements/tooltip";
import { T } from "components/util/t";
import { useMenuState } from "hooks/useMenuState";
import { useStartSirenAudio } from "./audio/useStartSirenAudio";
import { useFiveMinutesRemainingAudio } from "./audio/useFiveMinutesRemainingAudio";
import { Heat } from "graphql/generated/types";
import { useEndSirenAudio } from "./audio/useEndSirenAudio";

interface SoundToggleButtonProps {
    isMuted: boolean;
    setIsMuted: (value: boolean) => void;
}

type AudioButtonsProps = SoundToggleButtonProps & {
    heat: Partial<Heat>;
};

const SoundToggleButton: React.FC<SoundToggleButtonProps> = ({ isMuted, setIsMuted }) => {

    const handleToggle = () => {
        setIsMuted(!isMuted);
    };

    return (
        <Tooltip title={<T>{isMuted ? "Automatic siren is OFF" : "automatic_siren_is_on"}</T>}>
            <IconButton onClick={handleToggle} aria-label="Toggle audio">
                {isMuted ? <VolumeOff /> : <VolumeUp />}
            </IconButton>
        </Tooltip>
    );
};

const MenuButton: React.FC = () => {
    const [anchorEl, openMenu, closeMenu] = useMenuState();
    const { playStartSirenSound } = useStartSirenAudio({ isMuted: false });

    return (
        <>
            <IconButton
                aria-label="Audio menu"
                aria-controls="menu-dropdown"
                aria-haspopup="true"
                onClick={openMenu}
            >
                <MoreVert />
            </IconButton>
            <Menu
                id="menu-dropdown"
                anchorEl={anchorEl}
                open={!!anchorEl}
                onClose={closeMenu}
                variant="menu"
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
            >
                <MenuItem data-testid={"manual-siren-menu-item"} onClick={playStartSirenSound}>
                    <T>Manual siren (1 honk)</T>
                </MenuItem>
            </Menu>
        </>
    );
};

export const AudioButtons: React.FC<AudioButtonsProps> = ({ isMuted, setIsMuted, heat }) => {
    useFiveMinutesRemainingAudio({ isMuted, heat });
    useEndSirenAudio({ isMuted, heat });

    return (
        <Stack direction="row" spacing={1}>
            <SoundToggleButton isMuted={isMuted} setIsMuted={setIsMuted} />
            <MenuButton />
        </Stack>
    );
};
